<template>
  <ModelForm
    :places="places"
    :reports="reports"
    :user="form"
  />
</template>

<script>
import BaseLayout from '@/Layouts/BaseLayout';
import UiBreadcrumbs from '@/components/Ui/UiBreadcrumbs';
import UiErrors from '@/components/Ui/UiErrors';
import UiDeleteButton from '@/components/Ui/UiDeleteButton';
import Form from "./UsersForm";

export default {
  name: 'UsersCreate',
  components: {
    UiBreadcrumbs,
    BaseLayout,
    UiErrors,
    UiDeleteButton,
    ModelForm: Form
  },
  props: {
    reports: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => null
    },
    places: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      breadcrumbs: [
        {title: 'Список пользователей', href: route('users.index')},
      ],
      form: this.$inertia.form({
        _method: 'post',
        name: null,
        email: null,
        places: [],
        template_save_access: false,
        is_admin: false,
        password: null,
        reports: [],
      }),
      rules: {
        name: [
          {required: true, message: 'Обязательное поле', trigger: 'blur'},
        ],
        email: [
          {required: true, message: 'Обязательное поле', trigger: 'blur'},
        ],
      },
    };
  },
  computed: {
    isNew() {
      return false;
    },
    title() {
      return this.isNew ? 'Создание записи' : 'Изменение записи';
    },
  },
  methods: {
    deleteClick() {
      this.$inertia.delete(route('users.destroy', this.user.id), {
        onSuccess: () => {
          this.$notify.success({
            title: 'Пользователь удалён',
          });
        },
        onError: (errors) => {
          this.$notify.error({
            title: 'Ошибка',
            message: errors.exeption[0],
          });
        },
      });
    },
    validate() {
      return this.$refs.users_form.validate();
    },
    submitForm(settings) {
      const url = this.isNew ? route('users.store') : route('users.update', this.user.id);
      // Так как PUT метод не поддерживает загрузку файлов
      if (!this.isNew) {
        this.form._method = 'put';
      }
      return this.form.post(url, settings);
    },
    submit() {
      this.validate().then(() => {
        this.submitForm({
          onError: () => {
            this.$notify.error({
              title: 'Ошибка сохранения',
              message: 'Исправьте введенные данные',
            });
          },
        });
      }).catch(() => {
        this.$notify.error({
          title: 'Ошибки в форме',
          message: 'Заполните необходимые поля',
        });
      });
    }
  }
};
</script>
